import { ConsolePage, DStat } from '@/components';
import { useCertificates, useCourses, useUsers } from '@/hooks/queries';
import { CourseAnalyticsReport } from '@/features/instructor/InstructorAnalytics';

export function AdminReports() {
  const { data: certs = [] } = useCertificates();
  const { data: courses = [] } = useCourses();
  const { data: users = [] } = useUsers();

  const valid = certs.filter((c) => c.status === 'valid').length;
  const expiring = certs.filter((c) => c.status === 'expiring').length;
  const activeCourses = courses.filter((c) => c.status === 'active').length;

  return (
    <ConsolePage title="Reports" th="รายงาน" crumbs="OVERVIEW" maxWidth={1140}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: 14 }}>
          <DStat label="Certificates issued" value={String(certs.length)} icon="award" sub="to date" />
          <DStat label="Valid" value={String(valid)} icon="shield" tone="var(--sage)" />
          <DStat label="Expiring soon" value={String(expiring)} icon="clock" tone="var(--ochre)" />
          <DStat label="Active courses" value={String(activeCourses)} icon="book" sub={`${users.length} staff`} />
        </div>
        <CourseAnalyticsReport />
      </div>
    </ConsolePage>
  );
}
